<div bsModal [config]="{ignoreBackdropClick: true, keyboard: false}" #modal="bs-modal" class="modal-loader modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div class="info">
                    <div>
                        <span class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></span>
                    </div>
                    <div class="info-text">
                        <p>Por favor, aguarde.</p>
                        <p>{{message}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>